export default __webpack_public_path__ + "static/media/plus-blue.85eb24ca.svg";